import React, { useMemo } from 'react';
import { Filter, FilterFrame, FilterSelection, GroupWrapper } from '../Filters.style';
import { FilterOption } from '../../../types';
import CheckboxSelector from '../../CheckboxComponent';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import FilterExposedHeader from '../FilterExposedHeader';
import useAnimations from '../../../hooks/Animations/useAnimations';
import { AvailableFiltersCount } from '../../../types/oneGraphTypes';

interface GearboxSelectorTypes {
  filterType: string;
  filterOptions: AvailableFiltersCount[];
  confirmedFilters: FilterTypes;
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string) => void;
  handleExposeFilter: (arg: string) => void;
}

const GearboxSelector: React.FC<GearboxSelectorTypes> = ({
  filterType,
  filterOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const selectedGearbox = confirmedFilters.gearBox;

  const showFilter = openedFiltersList[filterType];

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);

  return (
    <Filter>
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedGearbox}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      {dropdownAnimation(
        (props, item) =>
          item && (
            <FilterSelection style={props} data-testid="gearbox-filter-group">
              <FilterFrame style={filtersAccordianAnimation}>
                <GroupWrapper>
                  {filterOptions.map((filterOption, index) => {
                    const { value, disabled } = filterOption;
                    return (
                      <CheckboxSelector
                        filterType={filterType}
                        inputName={`${filterType}-${value}`}
                        key={value}
                        onChange={() => handleAddFilter(filterType, value)}
                        value={value}
                        checked={selectedGearbox.includes(value)}
                        disabled={disabled}
                      />
                    );
                  })}
                </GroupWrapper>
              </FilterFrame>
            </FilterSelection>
          ),
      )}
    </Filter>
  );
};

export default GearboxSelector;
